import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

const fmtPeriodo = (p) => {
    if (!p) return '';
    if (typeof p === 'string') return p.substring(0, 10);
    return `${p.getFullYear()}-${String(p.getMonth() + 1).padStart(2, '0')}-${String(p.getDate()).padStart(2, '0')}`;
};

export const guardarLiquidacionPdf = (payload) =>
    axios.post(`${HOST_API}api/liquidacionBarrio/guardar`, payload);

export const getLiquidacionesBarrio = (barrioId, administracionId) =>
    axios.get(`${HOST_API}api/liquidacionBarrio/listar`, {
        params: { barrioId, administracionId },
    });

export const urlDescargarLiquidacionPdf = (barrioId, periodo, administracionId, usuarioId) =>
    `${HOST_API}api/liquidacionBarrio/descargar?barrioId=${barrioId}&periodo=${fmtPeriodo(periodo)}&administracionId=${administracionId}&usuarioId=${usuarioId}`;
